import type { AuthenticationResultSuccess } from "src/authentication/objects/Authentication";
import { useCookieState } from "src/shared/cookie/useCookieState";

export const useAuthenticationTokenCookie = () => {
  return useCookieState<AuthenticationResultSuccess>("raange-auth");
};
